import * as React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { StyledSectionHeader } from '../../../../themes/styled-components';

interface IClientCensusCard {
  client?: IClient;
}

export default function ClientCensusCard (props: IClientCensusCard) {
  return (
    <Box sx={{ height: '100%' }}>
      <Paper sx={{ height: '100%', p: 2}}>
        <StyledSectionHeader>Census</StyledSectionHeader>
        <Box display="flex" flexDirection="row" alignItems="center" sx={{ mb: 2 }}>
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: '900', fontSize: '0.7rem', mr: 1 }}>
            Available:
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ fontSize: '0.7rem' }}>
            {props.client?.IsCensusHistoricAvailable ? 'Yes' : 'No'}
          </Typography>
        </Box>
        <Box >
          <Typography variant="body2" color="text.secondary" sx={{ fontWeight: '900', fontSize: '0.7rem', mr: 1, mb: .5}}>
            Current year snapshot:
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ fontSize: '0.7rem' }}>            
            {props.client?.CensusCurrentYearSnapshot ? (props.client.CensusCurrentYearSnapshot !== '' ? props.client.CensusCurrentYearSnapshot : 'na') : 'na'}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}